var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildMultilingualLink } from '../../types/builders';
import { X_DEFAULT } from '../../consts';
import PROPS from '../../types/Props';
var REL = PROPS.REL, HREF = PROPS.HREF, HREFLANG = PROPS.HREFLANG;
export function getMultilingualSchemaFromContext(data, _a) {
    var _b = (_a === void 0 ? {} : _a).currentSchemas, currentSchemas = _b === void 0 ? [] : _b;
    var schemesHasMultilingualTags = currentSchemas.some(function (schema) {
        return hasMultilingualTags(schema === null || schema === void 0 ? void 0 : schema.tags);
    });
    if (schemesHasMultilingualTags) {
        return { tags: [] };
    }
    var _c = (data || {}).context, _d = _c === void 0 ? {} : _c, siteLanguages = _d.siteLanguages, siteUrl = _d.siteUrl;
    if (!(siteLanguages === null || siteLanguages === void 0 ? void 0 : siteLanguages.length)) {
        return { tags: [] };
    }
    var languages = __spreadArrays([
        { url: siteUrl, languageCode: X_DEFAULT }
    ], siteLanguages);
    var tags = getMultilingualTags(languages);
    return { tags: tags };
}
/**
 *
 * @param {Array<{
 * url: string,
 * langCode: string,
 * languageCode: string
 * }>} siteLanguages
 */
export function getMultilingualTags(siteLanguages) {
    var tagsMap = new Map();
    return (siteLanguages || [])
        .map(function (_a) {
        var url = _a.url, linkToPage = _a.linkToPage, langCode = _a.langCode, languageCode = _a.languageCode, language = _a.language;
        url = url || linkToPage;
        langCode = langCode || languageCode || language;
        var tag = url && langCode ? buildMultilingualLink(url, langCode) : undefined;
        return tag;
    })
        .filter(Boolean)
        .reverse()
        .reduce(function (tags, tag) {
        var _a = (tag === null || tag === void 0 ? void 0 : tag.props) || {}, _b = HREFLANG, hreflang = _a[_b];
        if (tagsMap.has(hreflang)) {
            return tags;
        }
        else {
            tagsMap.set(hreflang);
            return __spreadArrays([tag], tags);
        }
    }, []);
}
export function hasMultilingualTags(tags) {
    if (!Array.isArray(tags)) {
        return false;
    }
    return tags.some(function (tag) {
        var _a = (tag === null || tag === void 0 ? void 0 : tag.props) || {}, _b = REL, rel = _a[_b], _c = HREF, href = _a[_c], _d = HREFLANG, hreflang = _a[_d];
        return Boolean(rel && href && hreflang);
    });
}
